import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/vercel/path1/node_modules/@babel/runtime/regenerator/index.js";
import { useCopilotAction, useCopilotReadable, useCopilotAdditionalInstructions } from "@copilotkit/react-core";
import constants from "../../../../utils/constants";
import Store from "../../../../utils/Store";
import { useStoreState } from "pullstate";
import { MIXPANEL_EVENTS } from "../../../../utils/mixpanelEvents";
import { trackEvent } from "../../../../utils/mixpanel";
import { get } from "lodash";
var useChangeThemeWithAI = function useChangeThemeWithAI(isAIAssistantEnabled) {
  var _useStoreState = useStoreState(Store, function (store) {
      return {
        isDarkMode: store.isDarkMode
      };
    }),
    isDarkMode = _useStoreState.isDarkMode;
  var THEME_OPTIONS = ["light", "dark"];
  useCopilotReadable({
    description: "The current theme",
    value: isDarkMode ? "dark" : "light",
    available: isAIAssistantEnabled ? "enabled" : "disabled"
  });
  var onToggleThemeClick = function onToggleThemeClick(_isDarkMode) {
    if (window) {
      localStorage.setItem(constants.PERSISTED.isDarkMode, String(!isDarkMode));
      Store.update(function (s) {
        s.isDarkMode = _isDarkMode;
      });
      trackEvent(MIXPANEL_EVENTS.THEME_CHANGED, {
        isDarkMode: _isDarkMode
      });
    }
  };
  useCopilotAdditionalInstructions({
    instructions: "\n      The 'changeTheme' action is used to change or toggle app theme when user specifies to change theme or mode, not any other property.\n      Do not change the theme if user asks to go back to worklist or any other page.\n      ",
    available: isAIAssistantEnabled ? "enabled" : "disabled"
  });
  useCopilotAction({
    name: "changeTheme",
    available: isAIAssistantEnabled ? "enabled" : "disabled",
    description: "Use this action when user wants to change or toggle app theme.\n      If user specifies theme name, switch it to the specified theme or else switch it to the theme other than current theme.\n      If user specifies theme name same as current theme, ask user if they want to switch to other theme.\n      ",
    parameters: [{
      type: "string",
      name: "theme",
      "enum": THEME_OPTIONS,
      required: true,
      description: "Toggle or switch between light and dark theme if user does not specify the theme."
    }],
    handler: function () {
      var _handler = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
        var theme, _isDarkMode;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              theme = _ref.theme;
              _isDarkMode = theme === "dark";
              trackEvent(MIXPANEL_EVENTS.LLM_ACTION, {
                action: "changeTheme",
                isDarkMode: _isDarkMode
              });
              onToggleThemeClick(_isDarkMode);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function handler(_x) {
        return _handler.apply(this, arguments);
      }
      return handler;
    }()
  });
};
var useChangeTheme = function useChangeTheme() {
  var _useStoreState2 = useStoreState(Store, function (s) {
      return {
        userInfo: s.userInfo
      };
    }),
    userInfo = _useStoreState2.userInfo;
  var isAIAssistantEnabled = get(userInfo, ["settings", "ui_settings", "ai_assistant"], false);
  return useChangeThemeWithAI(isAIAssistantEnabled);
};
export default useChangeTheme;